import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  ChevronLargeUp,
  ChevronLargeDown,
} from 'AppSrc/core/components/common/svg-icons';
import {
  VIEW_TYPE_VIEW_CRQ_STANDARD,
} from 'AppSrc/core/components/view-crq-screen/view-crq-constants';
import {
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import moment from 'moment';

const CommsSectionSummaryHeaderConnect = ({ // Changing method Name to wrap within Connect
  open,
  toggleOpen,
  sectionIndex,
  sectionId,
  sectionTitle,
  viewType,
  formData, // Getting formData as an extra props for checking in this component
  network, // for use in rescheduling
  impactValue, // for use in rescheduling
  // notificationTitle,
  notificationDate,
  uid,
}) => {

  const notificationDateFormat = moment(notificationDate).format('DD/MM/YYYY');

  const baseClassName = 'section-summary-header';
  const classNames = [
    baseClassName,
    `${baseClassName}-${viewType}`,
  ];

  const className = classNames.join(' ');

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => toggleOpen(sectionIndex, uid)}
        className="section-title"
      >
        <div className="row-wrapper">
          <div className="width-50 initial-comms-font">
            {sectionTitle}
          </div>
          <div className="notification-date initial-comms-font">
            {notificationDateFormat}
          </div>
        </div>
      </button>
      <button
        type="button"
        onClick={() => toggleOpen(sectionIndex, uid)}
        className="open-close"
      >
        <div className="svg-container">
          {open ? <ChevronLargeUp /> : <ChevronLargeDown />}
        </div>
      </button>
    </div>
  );
};

CommsSectionSummaryHeaderConnect.propTypes = {
  open: PropTypes.bool,
  toggleOpen: PropTypes.func,
  sectionIndex: PropTypes.number,
  sectionId: PropTypes.string,
  sectionTitle: PropTypes.string,
  viewType: PropTypes.string,
  formData: formDataShape, // formData PropTypes checking
  impactValue: PropTypes.string,
  network: PropTypes.string,
  notificationDate: PropTypes.string,
  uid: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  isChangeAnalyst: state && state.auth.isChangeAnalyst,
});

const CommsSectionSummaryHeader = connect(
  mapStateToProps,
)(CommsSectionSummaryHeaderConnect); // Wrapping method SectionSummaryHeaderConnect within Connect

CommsSectionSummaryHeader.defaultProps = {
  viewType: VIEW_TYPE_VIEW_CRQ_STANDARD,
};

export { CommsSectionSummaryHeader };
